import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/_TBComponents/Text';

import { setIsFeedShowing } from '../../ducks/feedActions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const ButtonContainer = styled('div')`
  align-items: center;
  background-image: linear-gradient(to right, #ff6600, rgb(252, 96, 118));
  border-radius: 12px;
  display: flex;
  height: 70px;
  padding: 0px 10px;
  margin-bottom: 30px;
  justify-content: space-between;
  cursor: ${(props) => (props.isFeedShowing ? 'pointer' : '')};
  width: 600px;
  @media screen and (max-width: 640px) {
    width: 100%;
    max-width: 100%;
    min-width: 350px;
  }
`;

const LeftBox = styled('div')`
  align-items: center;
  display: flex;
`;

const NewPRButton = () => {
  const feedPRCount = useSelector((state) => state.feed.data.feedPRCount);
  const isFeedShowing = useSelector((state) => state.feed.data.isFeedShowing);
  const dispatch = useDispatch();

  // no functionality if already showing PR posts
  const handleClick = () => {
    if (isFeedShowing) {
      dispatch(setIsFeedShowing(false));
      feedTracker('Normal Mode', 'New PR button clicked - switch to PRs');
    }
  };

  const buttonText = `${feedPRCount} New PR${feedPRCount === 1 ? '' : 's'} Today!`;

  return (
    <ButtonContainer
      onClick={handleClick}
      isFeedShowing={isFeedShowing}
      aria-label='View new PRs'
    >
      <LeftBox>
        <IcomoonReact iconSet={iconSet} size={25} icon='ribbon' color='#ffffff' />
        <Text
          styledTextProps={{
            color: '#ffffff',
            fontSize: '16px',
            fontWeight: '500',
            marginLeft: '10px',
          }}
        >
          {buttonText}
        </Text>
      </LeftBox>
      {isFeedShowing && (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon='right-arrow'
          color='#ffffff'
        />
      )}
    </ButtonContainer>
  );
};
NewPRButton.propTypes = {};

export default NewPRButton;
